import React from 'react'
import { Form } from 'react-bootstrap'
import { isMobile } from 'react-device-detect'
import { Link } from 'react-router-dom'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcFlexBox,
  DcInput,
  DcLeftPanel,
  DcRightPanel,
  DcText,
  PixelBusinessDiagram,
  PixelDiv,
  PixelFlexBox,
  PixelText,
  colors,
} from 'pixel-base'
import styled from 'styled-components'

import FlagPK from 'utils/icons/flag-pk'
import FlagUS from 'utils/icons/flag-us'
import { AuthContext } from 'contexts/AuthContext'
const Signup = () => {
  const { dispatchSignup, formError } = React.useContext(AuthContext)

  // const [partnersData, setPartnersData] = React.useState<any>([])
  const [data, setData] = React.useState({
    business_name: '',
    email: '',
    full_name: '',
    password: '',
    phone_no: '',
    refer_code: 1,
  })

  const [internalError, setError] = React.useState({
    form: 'signup',
    enable: false,
    field: formError.error.split(' ')[0],
    error: formError.error,
  })

  const [countery, setCountery] = React.useState('PK')

  const handleSubmit = (e) => {
    e.preventDefault()
    const validPatterns = [/^\d{11}$/, /^\+92\d{10}$/, /^\+1\d{10}$/]
    const inputNumber = data.phone_no
    const isValidNumber = validPatterns.some((pattern) =>
      pattern.test(inputNumber),
    )
    if (isValidNumber) {
      dispatchSignup(data)
    } else {
      setError({
        form: 'signup',
        enable: false,
        field: 'Phone',
        error: 'Phone number format should be +923008700580',
      })
    }
  }

  // const partnersDataOptions = partnersData.map((partner) => {
  //   return {
  //     label: <PixelFlexBox>{partner.partner_name}</PixelFlexBox>,
  //     value: partner.id,
  //   }
  // })
  // React.useEffect(() => {
  //   get('/auth/signup/partners').subscribe((res: AjaxResponse<any>) => {
  //     if (res.response?.data) setPartnersData(res.response?.data)
  //   })
  // }, [])
  React.useEffect(() => {
    if (countery === 'PK') {
      setData({
        ...data,
        phone_no: '+92',
      })
    } else if (countery === 'US') {
      setData({
        ...data,
        phone_no: '+1',
      })
    }
  }, [countery])
  React.useEffect(() => {
    setError({
      ...internalError,
      field: formError.error.split(' ')[0],
      error: formError.error,
    })
    if (formError.error.split(' ')[0] == 'Unable') {
      setError({ ...internalError, enable: true, error: formError.error })
    }
  }, [formError])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (countery === 'PK') {
      if (e.target.value.length <= 13) {
        const newValue = e.target.value
        if (e.target.value.startsWith('+92')) {
          setData({
            ...data,
            phone_no: newValue,
          })
          setError({ ...internalError, enable: false })
        }
      }
    } else if (countery === 'US') {
      if (e.target.value.length <= 12) {
        const newValue = e.target.value
        if (newValue.startsWith('+1')) {
          setData({
            ...data,
            phone_no: newValue,
          })
          setError({ ...internalError, enable: false })
        }
      }
    }
  }

  return (
    <>
      <DcFlexBox
        width="100%"
        height="100vh"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        style={{ background: colors.grayLightBg }}
      >
        <DcFlexBox
          width={isMobile ? '100%' : '1270px'}
          height={isMobile ? '100%' : '684px'}
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          borderRadius="15px"
          background="#ffffff"
          boxShadow="0 1px 0 rgba(232,231,236,.5)"
        >
          {!isMobile && (
            <DcLeftPanel
              height="684px"
              width=" 59% !important"
              backgroundColor={colors.authBg}
              borderRadius="15px 0 0 15px"
              style={{
                width: '100%',
                background: colors.authBg,
                overflow: 'hidden',
              }}
            >
              {/* <PixelFlexBox height="100%">
              <BgImage>
                <DcDiv
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                  }}
                ></DcDiv>
              </BgImage>
            </PixelFlexBox> */}
              <PixelBusinessDiagram />
            </DcLeftPanel>
          )}

          <DcRightPanel
            height={isMobile ? '100%' : '684px'}
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            padding="40px"
            width={isMobile ? '100%' : '42%'}
            backgroundColor="#ffffff"
            borderRadius="0px 15px 15px 0px"
            style={{
              border: '1px solid #e8e7ec',
            }}
          >
            <PixelFlexBox
              width="100%"
              maxWidth={isMobile ? '100%' : '1600px'}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <DcText
                style={{
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: '700',
                  fontSize: '1.25rem',
                  color: '#43476b',
                  marginBottom: '6px',
                }}
              >
                Create New Account
              </DcText>
              <PixelText
                customColor="#4d6575"
                style={{
                  fontSize: '.875rem',
                  textAlign: 'center',
                }}
              >
                {' '}
                <strong>Automation</strong> keeps you ahead of the curve, in
                front of your customers
              </PixelText>
              <Form
                style={{
                  width: '100%',
                  textAlign: 'center',
                }}
                onSubmit={handleSubmit}
              >
                <PixelDiv
                  width="100%"
                  height="auto"
                  style={{
                    display: 'flex',

                    flexDirection: 'column',
                    alignItems: 'flexStart',
                  }}
                >
                  <DcText
                    style={{
                      textAlign: 'left',

                      color: '#2e314a',
                      fontSize: '.875rem',
                      fontWeight: '500',
                      marginBottom: '.5rem',
                    }}
                  >
                    Name
                  </DcText>
                  <DcInput
                    style={{ padding: '9px 18px' }}
                    type="text"
                    value={data.full_name}
                    onChange={(e) =>
                      setData({
                        ...data,
                        full_name: e.currentTarget.value,
                      })
                    }
                    required
                    name="name"
                    placeholder="Full Name"
                  />
                  {/* {getError()} */}
                </PixelDiv>
                <PixelDiv
                  width="100%"
                  height="auto"
                  style={{
                    display: 'flex',

                    flexDirection: 'column',
                    alignItems: 'flexStart',

                    marginTop: '16px',
                  }}
                >
                  <DcText
                    style={{
                      textAlign: 'left',

                      color: '#2e314a',
                      fontSize: '.875rem',
                      fontWeight: '500',
                      marginBottom: '.5rem',
                    }}
                  >
                    Business Name
                  </DcText>
                  <DcInput
                    style={{
                      padding: '9px 18px',
                    }}
                    isShowError={internalError.field == 'Business'}
                    errorMessage={internalError.error}
                    type="text"
                    name="business"
                    placeholder="Business Name"
                    value={data.business_name}
                    onChange={(e) =>
                      setData({
                        ...data,
                        business_name: e.currentTarget.value,
                      })
                    }
                    required
                  />
                  {/* {getError()} */}
                </PixelDiv>

                <PixelDiv
                  width="100%"
                  height="auto"
                  style={{
                    display: 'flex',

                    flexDirection: 'column',
                    alignItems: 'flexStart',

                    marginTop: '16px',
                  }}
                >
                  <DcText
                    style={{
                      textAlign: 'left',

                      color: '#2e314a',
                      fontSize: '.875rem',
                      fontWeight: '500',
                      marginBottom: '.5rem',
                    }}
                  >
                    Email
                  </DcText>
                  <DcInput
                    style={{
                      padding: '9px 18px',
                    }}
                    isShowError={internalError.field == 'Email'}
                    errorMessage={internalError.error}
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={data.email}
                    onChange={(e) =>
                      setData({
                        ...data,
                        email: e.currentTarget.value,
                      })
                    }
                    required
                  />
                </PixelDiv>
                <PixelFlexBox
                  style={{
                    height: 'auto',
                    marginBottom: '10px',
                    gap: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <PixelFlexBox gap="10px">
                    <PixelDiv
                      width="65%"
                      height="auto"
                      style={{
                        display: 'flex',

                        flexDirection: 'column',
                        alignItems: 'flexStart',

                        marginTop: '16px',
                      }}
                    >
                      <DcText
                        style={{
                          textAlign: 'left',

                          color: '#2e314a',
                          fontSize: '.875rem',
                          fontWeight: '500',
                          marginBottom: '.5rem',
                        }}
                      >
                        Country
                      </DcText>
                      <DcDropDown
                        // style={{ padding: '10px' }}
                        placeholder={'Select Country'}
                        options={[
                          {
                            label: (
                              <PixelFlexBox gap="5px">
                                <FlagPK />
                                <PixelText>PK</PixelText>
                              </PixelFlexBox>
                            ),
                            value: 'PK',
                          },
                          {
                            label: (
                              <PixelFlexBox gap="5px">
                                <FlagUS />
                                <PixelText>US</PixelText>
                              </PixelFlexBox>
                            ),
                            value: 'US',
                          },
                        ]}
                        value={countery}
                        onChange={(e) => {
                          setCountery(e.target.value)
                        }}
                      />
                    </PixelDiv>

                    <PixelDiv
                      style={{
                        width: '65%',
                        display: 'flex',

                        flexDirection: 'column',
                        alignItems: 'flexStart',

                        marginTop: '16px',
                      }}
                    >
                      <DcText
                        style={{
                          textAlign: 'left',

                          color: '#2e314a',
                          fontSize: '.875rem',
                          fontWeight: '500',
                          marginBottom: '.5rem',
                        }}
                      >
                        Phone
                      </DcText>
                      <DcInput
                        style={{
                          padding: '9px 18px',
                        }}
                        isShowError={internalError.field == 'Phone'}
                        errorMessage={internalError.error}
                        type="text"
                        value={data.phone_no}
                        onChange={handleChange}
                        required
                        name="phone"
                        placeholder="Phone"
                      />
                    </PixelDiv>
                  </PixelFlexBox>
                  {/* {getError()} */}
                </PixelFlexBox>

                <PixelDiv
                  style={{
                    width: '100%',
                    display: 'flex',

                    flexDirection: 'column',
                    alignItems: 'flexStart',

                    marginTop: '16px',
                  }}
                >
                  <DcText
                    style={{
                      textAlign: 'left',

                      color: '#2e314a',
                      fontSize: '.875rem',
                      fontWeight: '500',
                      marginBottom: '.5rem',
                    }}
                  >
                    Password
                  </DcText>
                  <DcInput
                    style={{
                      padding: '9px 18px',
                    }}
                    value={data.password}
                    as="password"
                    onChange={(e) =>
                      setData({
                        ...data,
                        password: e.currentTarget.value,
                      })
                    }
                    required
                    type="password"
                    name="password"
                    placeholder="Password"
                  />
                </PixelDiv>
                {/* <PixelDiv
                  width="100%"
                  height="auto"
                  style={{
                    display: 'grid !important',
                    marginBottom: '10px',
                    gridRowGap: '10px',
                  }}
                >
                  <DcDropDown
                    onChange={(e) =>
                      setData({
                        ...data,
                        refer_code: e.target.value,
                      })
                    }
                    value={data.refer_code}
                    options={partnersDataOptions}
                    name="Select Your Reference"
                    placeholder="Select Your Reference"
                  />
                  {getError('password')}
                </PixelDiv> */}

                <PixelDiv
                  style={{
                    width: '100%',
                    display: 'flex',

                    flexDirection: 'column',
                    alignItems: 'flexStart',

                    marginTop: '16px',
                  }}
                >
                  {internalError.enable && (
                    <PixelText customColor="red" textSize="80%">
                      {internalError.error}
                    </PixelText>
                  )}
                  <DcButton
                    style={{ width: '100%', padding: '9px 18px' }}
                    // margin="0 50px"
                    type="submit"
                    variant="gradient"
                    width="100%"
                  >
                    Sign Up
                  </DcButton>
                </PixelDiv>
                <DcDiv style={{ display: 'flex', justifyContent: 'center' }}>
                  <Divider>OR</Divider>
                </DcDiv>
                <PixelText
                  textSize="14px"
                  style={{
                    fontWeight: '400',
                    letterSpacing: 'normal',
                    lineHeight: '19.6px',
                    textAlign: 'center',
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '3px',

                    // margin: '10px 0px',
                  }}
                  customColor="rgb(77, 101, 117)"
                >
                  Already have an account?
                  <DcButton
                    style={{
                      textDecoration: 'none',
                      color: 'rgb(95 56 249) !important',
                      margin: 'none',
                    }}
                    variant="link"
                    padding="0px"
                  >
                    <Link style={{ margin: 'none' }} to={'/auth/login'}>
                      <DcButton
                        padding="0"
                        variant="link"
                        style={{
                          fontSize: '.875rem',
                          margin: 'none !important',
                        }}
                      >
                        Login now.
                      </DcButton>
                    </Link>
                  </DcButton>
                </PixelText>
              </Form>
            </PixelFlexBox>
          </DcRightPanel>
        </DcFlexBox>
      </DcFlexBox>
    </>
  )
}
// we will remove this styled component when did we create the left section

const BgImage = styled.div`
  background-image: url('https://react.nioboard.themenio.com/static/media/a.23bd4f13bb2b41d70a8f.png');
  height: 150px;
  width: 100%;
  background-size: cover;
  padding: 150px 20px 20px 20px;

  @media (min-width: 768px) {
    height: 200px;
    width: 504px;
    padding: 200px 40px 40px 40px;
  }
`

const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin: 10px 0;
  font-size: 14px;
  color: #555;
  position: relative;
  text-align: center;

  &::before,
  &::after {
    content: '';
    flex-grow: 1;
    height: 2px;
    background-color: #ccc;
    position: relative;
  }

  &::before {
    margin-right: 10px;
  }

  &::after {
    margin-left: 10px;
  }

  @media (min-width: 768px) {
    width: 30%;
  }
`
export default Signup
